import { render } from "./QuestionsResolver.vue?vue&type=template&id=44861a62"
import script from "./QuestionsResolver.vue?vue&type=script&lang=ts"
export * from "./QuestionsResolver.vue?vue&type=script&lang=ts"
script.render = render

export default script